import { Ajax, AjaxError, ISupportSpinner } from '../shared/Ajax'

export class AnnouncementController extends Ajax {
  constructor() {
    super(window.__emdgBaseUrl, '/')
  }

  getLoginPageAnnouncement(owner: ISupportSpinner, success: { (res: string): any }, error?: AjaxError) {
    super._call('get', 'GetLoginPageAnnouncement', owner, null, null, success, error, 'text')
  }
}
